import { Box, styled } from "@mui/material";
import BottomCurvedPolygon from "../../../assets/images/bottom-curved-polygon.svg";
import UpperCurvedPolygon from "../../../assets/images/upper-curved-polygon.svg";
import { LazoLogoWhite } from "./LazoLogo";

const BackgroundContainer = styled(Box)(() => ({
  overflow: "hidden",
  display: "flex",
  position: "absolute",
  width: "100dvw",
  height: "100%",
}));

const StyledImage = styled("img")<{ fullwidth: boolean }>(({ theme, fullwidth }) => ({
  "&.upper-curved-polygon": {
    position: "absolute",
    top: "-0.312rem",
    left: "-6.312rem",
    width: fullwidth ? "44.000rem" : "50%",
    [theme.breakpoints.down("md")]: {
      width: "31.250rem",
    },
    [theme.breakpoints.down("sm")]: {
      width: "18.750rem",
    },
  },
  "&.bottom-curved-polygon": {
    position: "absolute",
    bottom: "-7.500rem",
    right: fullwidth ? "-11.312rem" : "50%",
    width: "75.312rem",
    height: "36.500rem",
    [theme.breakpoints.down("md")]: {
      width: "43.750rem",
    },
    [theme.breakpoints.down("sm")]: {
      width: "18.750rem",
    },
  },
}));

interface LazoBackgroundProps {
  showLogo?: boolean;
  fullwidth?: boolean;
  width?: string;
}

function LazoPurpleBackground(props: LazoBackgroundProps) {
  const { showLogo = true, fullwidth = true } = props;
  return (
    <BackgroundContainer sx={props.width && { width: props.width }} id="Lazo-background">
      {
        <LazoLogoWhite
          styles={{
            position: "absolute",
            left: "1.25rem",
            top: "0.875rem",
            height: "2.375rem",
            display: showLogo ? "initial" : "none",
          }}
        />
      }
      <StyledImage className="upper-curved-polygon" src={UpperCurvedPolygon.src} alt="upper-curved-polygon" fullwidth={fullwidth} />
      <StyledImage src={BottomCurvedPolygon.src} alt="bottom-curved-polygon" className="bottom-curved-polygon" fullwidth={fullwidth} />
    </BackgroundContainer>
  );
}

export default LazoPurpleBackground;
